const market = {
	dsbz: 'Jetons en attente de liste',
	kpsj:'Compte à rebours/Heure d ouverture',
	ykp: 'Ouvert',
	kpdjs: 'Compte à rebours d ouverture',
	worning: 'Prix non définitif,仅供参考',
	swapTab_1: 'Contrats USDT',
	swapTab_2: 'Contrats en jeton',
	searchCoin: 'Rechercher un jeton',
	risk: 'Avertissement de risque',
	addSelfCode: 'Ajouter aux favoris',
	pair: 'Paire',
	latestPrice: 'Dernier prix',
	changeHour: 'Variation',
	highHour: 'Plus haut 24H',
	lowHour: 'Plus bas 24H',
	priceTrend: 'Tendance des prix (3 jours)',
	volumeHour: 'Volume 24H',
	noSearch: 'Aucun jeton trouvé',
	noAdd: 'Pas encore de favoris',
	noYet: 'Ce jeton n est pas encore listé',
	noBi: 'Ce jeton n est pas encore lancé',
	wan: 'dix mille',
	qian: 'mille',
	yi: 'cent million',
	yxhy: 'Contrats perpétuels',
	wghy: 'Contrats grid',
	cxjy:
		'La zone d innovation compte des jetons qui ont atteint des résultats en technologie et marché, mais他们的价格波动较大，风险也相对较高。建议您仔细查阅相关资料，在自身可承受范围内决定是否参与。',
	qljy:
		'La zone prometteuse est encore à un stade précoce de développement. Biking ne peut garantir leur valeur共识et leur liquidité. Veuillez examiner attentivement les informations du projet.',
	qljyDao: 'La zone DAO est encore à un stade précoce. Biking ne peut garantir leur valeur et liquidité.',
	default: 'La zone de trading est encore à un stade précoce. Biking ne peut garantir leur valeur et liquidité.',
  storage: 'La zone de stockage est encore à un stade précoce. Biking ne peut garantir leur valeur et liquidité.',
	dlt:
		'La zone de faible liquidité a une liquidité réduite. Il y a un risque de Radiation et de retrait du marché.。建议您谨慎考虑。',
	defi:
		'La zone DEFI est encore à un stade précoce. Biking ne peut garantir leur valeur共识et leur liquidité.',
	nft: "La zone NFT est encore à un stade précoce. Biking ne peut garantir leur valeur共识et leur liquidité.",

	hz: "Perpétuel",
	yx: "Sélection",
	yjyzx: "Projets sélectionnés par l institut",
	zx: 'Favoris',
	bb: 'Spot',
	hy: 'Contrats',
	zfb: 'Classement des gains',
	xbb: 'Nouveaux jetons',
	bd: 'Paire',
	zxj: 'Dernier prix',
	zdf24: 'Variation 24H',
	high24: 'Plus haut 24H',
	low24: 'Plus bas 24H',
	turnover24: 'Volume 24H',
	zd24: 'Variation 24h',
	zjrzd: 'Prix/Variation journalière',
	scgl: 'Aperçu du marché',
	jysj: 'Données de trading',
	fyje: "Montant des commission",
	ms: "Oui",
    mf: "Non",
	是否交易:'Négocier',
	推荐好友:'Recommander un ami',
	推荐: "Recommander",
	合约交易返佣:'Obtenez des commissions élevées sur les contrats',
	我的返佣比例:'Mon taux de commission',
	好友返佣比例:'Taux de commission de l ami',
	推荐码:'Code de recommandation',
	交易人数:'Nombre de traders',
	推荐总览:'Aperçu des recommandations',
	推荐人数:'Nombre de personnes invitées',
	推荐链接:'Lien de recommandation',
	一键分享:'Partager en un clic',
	合约返佣:'Commissions cumulées sur contrats',
	推荐记录:'Historique des recommandations',
	返佣记录:'Historique des commissions',
	推荐好友:'Inviter des amis',
	请输入账户UID:'Veuillez entrer l UID du compte',
	账户UID:'UID du compte',
	注册时间:'Date d inscription (UTC+8)',
	合约手续费:'Frais de contrat',
	返佣活动规则说明:'Règles de l activité de commission :',
	使用你的推荐链接:'Seuls les utilisateurs qui s inscrivent via votre lien ou code de recommandation comptent comme vos filleuls.',
	被邀请人产生的真实交易手续费:'Les frais de trading réels générés par le filleul donneront droit à une commission pour l inviteur.',
	用户邀请朋友无上限:'Les utilisateurs peuvent inviter autant d amis qu ils le souhaitent. Seuls les frais de trading de contrats comptent pour les commissions.',
	被邀请人只有进行合约:'Seuls les frais de trading de contrats du filleul comptent pour les commissions.',
	不允许任何用户通过多:'Les auto-invitations via plusieurs comptes ne sont pas autorisées. Toutes les commissions seront annulées.',
	由于市场环境的改变:'En raison de l évolution du marché et des risques de fraude, Biking se réserve le droit de modifier les règles de commission.',
	保留对活动的最终解释权:'Pour toute question, veuillez contacter le support.'
};

export { market };


// WEBPACK FOOTER //
// ./src/i18n/lang/market/fr.js